setTimeout(function () {
    $('body').removeClass('loaded');
    $('.video--loading').addClass('fade')
}, 4500);
